const Loading = () => {
  return <div className="loader h-screen w-full absolute"></div>;
};

export default Loading;
